import { Routes } from '@angular/router';
import { redirectIfAuthenticated, requireVendorAuthenticated, requireVendorLogin } from './core/guards/vendor-auth.guard';
import { requireGroceryVendor, requireNonGroceryVendor } from './core/guards/grocery-vendor.guard';
import { requireOnboardingStep } from './core/guards/onboarding-step.guard';
import { VendorShellComponent } from './core/layout/vendor-shell.component';

console.log('[Vendor Routes] Routes module loaded');
console.log('[Vendor Routes] VendorShellComponent:', VendorShellComponent);

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
  {
    path: 'auth',
    canActivate: [redirectIfAuthenticated],
    loadComponent: () => {
      console.log('[Vendor Routes] Loading AuthShellPage...');
      return import('./pages/auth/auth-shell.page').then((m) => {
        console.log('[Vendor Routes] AuthShellPage loaded:', m.AuthShellPage);
        return m.AuthShellPage;
      }).catch((err) => {
        console.error('[Vendor Routes] Failed to load AuthShellPage:', err);
        throw err;
      });
    },
    children: [
      {
        path: 'login',
        loadComponent: () => {
          console.log('[Vendor Routes] Loading LoginPage...');
          return import('./pages/auth/login.page').then((m) => {
            console.log('[Vendor Routes] LoginPage loaded:', m.LoginPage);
            return m.LoginPage;
          }).catch((err) => {
            console.error('[Vendor Routes] Failed to load LoginPage:', err);
            throw err;
          });
        },
      },
      // Registration disabled - users must be created via admin portal
      // {
      //   path: 'register',
      //   loadComponent: () => import('./pages/auth/register.page').then((m) => m.RegisterPage),
      // },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
    ],
  },
  {
    path: 'onboarding',
    canActivate: [requireVendorLogin],
    loadComponent: () => import('./pages/onboarding/onboarding-shell.page').then((m) => m.OnboardingShellPage),
    children: [
      {
        path: 'details',
        loadComponent: () => import('./pages/onboarding/onboarding-details.page').then((m) => m.OnboardingDetailsPage),
      },
      {
        path: 'documents',
        canActivate: [requireOnboardingStep],
        loadComponent: () =>
          import('./pages/onboarding/onboarding-documents.page').then((m) => m.OnboardingDocumentsPage),
      },
      {
        path: 'review',
        canActivate: [requireOnboardingStep],
        loadComponent: () => import('./pages/onboarding/onboarding-review.page').then((m) => m.OnboardingReviewPage),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'details',
      },
    ],
  },
  {
    path: 'tabs',
    component: VendorShellComponent,
    canActivate: [requireVendorAuthenticated],
    canActivateChild: [requireVendorAuthenticated],
    children: [
      {
        path: 'dashboard',
        redirectTo: 'orders',
        pathMatch: 'full',
      },
      {
        path: 'orders',
        loadComponent: () => import('./pages/orders/orders.page').then((m) => m.OrdersPage),
      },
      {
        path: 'orders-history',
        loadComponent: () =>
          import('./pages/orders-history/orders-history.page').then((m) => m.OrdersHistoryPage),
      },
      {
        path: 'products',
        loadComponent: () => import('./pages/products/products.page').then((m) => m.ProductsPage),
      },
      {
        path: 'custom-menu-categories',
        canActivate: [requireNonGroceryVendor],
        loadComponent: () =>
          import('./pages/custom-menu-categories/custom-menu-categories.page').then(
            (m) => m.CustomMenuCategoriesPage,
          ),
      },
      {
        path: 'earnings',
        loadComponent: () => import('./pages/earnings/earnings.page').then((m) => m.EarningsPage),
      },
      {
        path: 'campaigns',
        loadComponent: () => import('./pages/campaigns/campaigns.page').then((m) => m.CampaignsPage),
      },
      {
        path: 'store',
        loadComponent: () => import('./pages/store/store.page').then((m) => m.StorePage),
      },
      {
        path: 'pos-users',
        loadComponent: () => import('./pages/pos-users/pos-users.page').then((m) => m.PosUsersPage),
      },
      {
        path: 'delivery',
        loadComponent: () => import('./pages/delivery/delivery.page').then((m) => m.DeliveryPage),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/notifications/notifications.page').then((m) => m.NotificationsPage),
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/settings/settings.page').then((m) => m.SettingsPage),
      },
      {
        path: 'ratings',
        loadComponent: () => import('./pages/ratings/ratings.page').then((m) => m.RatingsPage),
      },
      {
        path: 'inventory',
        loadComponent: () => import('./pages/inventory/inventory.page').then((m) => m.InventoryPage),
        canActivate: [requireGroceryVendor],
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'orders',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'auth/login',
  },
];
